import React, { useState, useRef } from "react";
import styles from "../main.module.css";
import LoadingSpinner from "../../../components/common/LoadingSpinner";

const PdfUploadModal = ({ isVisible, onClose, onConvert, isConverting }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const resetSelection = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file || null);
  };

  const handleConvert = () => {
    if (selectedFile) {
      onConvert(selectedFile);
    }
  };

  const handleClose = () => {
    resetSelection();
    onClose();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const [file] = event.dataTransfer.files;
    if (!file) {
      return;
    }

    const fileName = file.name.toLowerCase();
    if (file.type === "application/pdf" || fileName.endsWith(".pdf")) {
      setSelectedFile(file);
    }
  };

  if (!isVisible) return null;

  return (
    <div className={styles.modalBackdrop} onClick={handleClose}>
      <div
        className={styles.modalContentWrapper}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h3>
            <i className="fas fa-file-pdf mr-2"></i>Upload PDF File
          </h3>
          <button onClick={handleClose} className={styles.modalCloseBtn}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.uploadSection}>
            <div
              className={styles.fileDropZone}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
            >
              <div className={styles.uploadIcon}>
                <i className="fas fa-cloud-upload-alt"></i>
              </div>
              <div className={styles.uploadText}>
                <p>
                  <strong>Choose a PDF file or drag it here</strong>
                </p>
                <p className={styles.uploadSubtext}>
                  Supported format: PDF (Max 20MB)
                </p>
              </div>
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,application/pdf"
                onChange={handleFileSelect}
                style={{ display: "none" }}
              />
            </div>

            {selectedFile && (
              <div className={styles.selectedFile}>
                <div className={styles.fileInfo}>
                  <i className="fas fa-file-pdf"></i>
                  <div className={styles.fileDetails}>
                    <span className={styles.fileName}>{selectedFile.name}</span>
                    <span className={styles.fileSize}>
                      {(selectedFile.size / (1024 * 1024)).toFixed(2)} MB
                    </span>
                  </div>
                </div>
                <button
                  onClick={resetSelection}
                  className={styles.removeFileButton}
                  title="Remove file"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={handleClose}
            className={`${styles.actionButton} ${styles.actionButtonSecondary}`}
            disabled={isConverting}
          >
            Cancel
          </button>
          <button
            onClick={handleConvert}
            className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
            disabled={!selectedFile || isConverting}
          >
            {isConverting ? (
              <LoadingSpinner small centered={false} />
            ) : (
              "Extract Text"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PdfUploadModal;
